import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';

const StyledContainer = styled.div`
  width: 100%;
  max-width: ${({ $narrow }) => ($narrow ? tokens.container.maxWidthNarrow : tokens.container.maxWidth)};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${tokens.spacing.lg};
  padding-right: ${tokens.spacing.lg};
`;

export function Container({ narrow, children, ...props }) {
  return (
    <StyledContainer $narrow={narrow} {...props}>
      {children}
    </StyledContainer>
  );
}

export default Container;
